import type {BrandedDividerParams} from '../WebGLContext/WebGLContext.types'

export type BrandedDividerViewport = 'desktop' | 'mobile' | 'tablet'

export async function getBrandedDividerFallback(
  {character, layout}: BrandedDividerParams,
  viewport: BrandedDividerViewport,
) {
  if (layout === 3 && character !== 'security') return

  const fallbackModule = await import(
    `../../assets/images/fallbacks/brandedDivider/${viewport}-${character}-${layout}.webp`
  )
  return fallbackModule.default
}
